<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-12 card" style="margin-left: 10px">
        <div style="margin: 0 20px 20px 20px">
          <ul style="color: #000">
            <li
              v-for="(includes, board) in boards"
              :class="{ active: selBoard === board }"
              v-on:click="
                selBoard = board;
                loadBoard();
              "
              v-bind:key="board"
              style="font-size:20px;important;font-weight:bold;"
            >
              <a href="#" data-toggle="tab">{{ board }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                통계관리
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  통계관리 → ID
                </div>
              </h5>
              <query-grid :config="config" ref="qg">
                <template #search_main="props">
                  <button
                    class="btn btn-danger btn-sm"
                    style="width: 20%"
                    @click="
                      firstselected = 0;
                      viewSecond();
                      props.callback(firstselected);
                    "
                  >
                    전체</button
                  ><br />
                  <button
                    class="btn btn-warning btn-sm"
                    style="width: 20%; margin: 2px"
                    v-for="firstlist in firstlists"
                    v-bind:key="firstlist.id"
                    @click="
                      firstselected = firstlist.id;
                      viewSecond();
                      props.callback(firstselected);
                    "
                  >
                    {{ firstlist.name }}
                  </button>
                </template>
                <template #search_sub="props">
                  <select
                    v-model="subselected"
                    @change="
                      props.callback(subselected);
                      this.$refs.qg.search();
                    "
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>캠퍼스</option>
                    <option
                      v-for="sublist in sublists"
                      :value="sublist.id"
                      v-bind:key="sublist.id"
                    >
                      {{ sublist.name }}
                    </option>
                  </select>
                </template>
                <template #search_vol="props">
                  <select
                    v-model="volselected"
                    @change="
                      props.callback(volselected);
                      this.$refs.qg.search();
                    "
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>Volume</option>
                    <option
                      v-for="vollist in vollists"
                      :value="vollist.No"
                      v-bind:key="vollist.No"
                    >
                      {{ vollist.Vol }}
                    </option>
                  </select>
                </template>
                <template #items="props">
                  <tr
                    v-for="article in props.records"
                    v-bind:key="article.s_int"
                  >
                    <td scope="col" style="text-align: center; padding: 15px 0">
                      {{ article.sInt }}
                    </td>
                    <td scope="col" style="text-align: center">
                      <Business v-if="article.parent" :biz="article.parent" />
                    </td>
                    <td scope="col" style="text-align: center">
                      <Business
                        v-if="article.searchvalue"
                        :biz="article.searchvalue"
                      />
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ article.subid }}
                    </td>
                  </tr>
                </template>
              </query-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid.vue";
import Business from "../components/Business";
export default {
  components: {
    QueryGrid,
    Business,
  },
  data: () => ({
    boards: {},
    articles: [],
    selBoard: "",
    search: "",
    firstlists: [],
    firstselected: "1",
    subselected: "",
    sublists: [],
    volselected: "",
    vollists: [],
    config: {
      name: "통계관리 매출",
      req_endpoint: "/admin/stat_id",
      default_limit: 20,
      search_fields: [
        {
          id: "cate_filter_main",
          name: "본부분류",
          type: "custom",
          custom_name: "main",
        },
        {
          id: "cate_filter_sub",
          name: "캠퍼스분류",
          type: "custom",
          custom_name: "sub",
        },
        {
          id: "month",
          name: "기간",
          type: "month", // business, date, datetime,
        },
      ],
      columns: [
        {
          id: "id",
          name: "번호",
          excel_print: (v) => {
            return v.sInt;
          },
        },
        {
          id: "parent",
          name: "본부",
          excel_print: (v) => {
            return v.parent.name;
          },
        },
        {
          id: "searchvalue",
          name: "캠퍼스",
          excel_print: (v) => {
            return v.searchvalue.name;
          },
        },
        {
          id: "countid",
          name: "ID 수",
          excel_print: (v) => {
            return v.subid;
          },
        },
      ],
    },
  }),
  methods: {
    loadBoard() {
      var extras = "?";
      if (this.search) {
        extras += "&search=" + this.search;
      }
      if (this.subselected) {
        extras += "&cate_filter_type=sub&cate_filter_var=" + this.subselected;
      } else if (this.firstselected) {
        extras +=
          "&cate_filter_type=main&cate_filter_var=" + this.firstselected;
      }
      axios.get("/admin/stat_id" + extras).then((response) => {
        if (response.data.error) {
          alert("ID 메출을 집계 할 수 없습니다.\n" + response.data.error);
        } else {
          this.articles = response.data.result.articles;
        }
      });
    },
    viewSecond() {
      this.$refs.qg.pushSetting("cate_filter_sub", null);
      this.subselected = null;
      axios
        .get("/admin/sub_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
  },
  mounted() {
    //this.loadBoard()
    axios.get("/admin/sub_categories").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
        //console.log(this.firstlists);
      }
    });
  },
};
</script>
